<script lang="ts">
  import AppShell from '$lib/ui/AppShell.svelte';
</script>

<AppShell />
